import type { ProductRecommendation } from '../engines/types';

function createProductImage(label: string, accent: string): string {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="640" height="480" viewBox="0 0 640 480">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${accent}" />
          <stop offset="100%" stop-color="#172033" />
        </linearGradient>
      </defs>
      <rect width="640" height="480" fill="url(#bg)" rx="36" />
      <rect x="54" y="54" width="532" height="372" rx="26" fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.18)" />
      <text x="320" y="214" text-anchor="middle" fill="#ffffff" font-size="34" font-family="Arial, sans-serif" font-weight="700">${label}</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export const PRODUCT_RECOMMENDATIONS: ProductRecommendation[] = [
  {
    category: 'heater',
    name: 'Harvia Legend 8 kW',
    description: 'Elaggregat för 7–13 m³ med robust stenkapacitet.',
    descriptionEn: 'Electric heater for 7–13 m³ with a generous stone capacity.',
    priceSek: 11995,
    imageUrl: createProductImage('Harvia Legend 8 kW', '#b2641b'),
    affiliateUrl: 'https://example.com/harvia-legend-8kw',
    heaterTypes: ['electric'],
    kwRange: [7, 9],
  },
  {
    category: 'heater',
    name: 'Narvi Smooth 9 kW',
    description: 'Elaggregat med mjuk styrning för 8–14 m³ basturum.',
    descriptionEn: 'Electric heater with smooth control for 8–14 m³ hot rooms.',
    priceSek: 12690,
    imageUrl: createProductImage('Narvi Smooth 9 kW', '#8a4f2b'),
    affiliateUrl: 'https://example.com/narvi-smooth-9kw',
    heaterTypes: ['electric'],
    kwRange: [8, 10],
  },
  {
    category: 'heater',
    name: 'HUUM Drop 9 kW',
    description: 'Designat elaggregat med generös stenvolym för premiumkänsla.',
    descriptionEn: 'Design electric heater with a large stone volume.',
    priceSek: 14990,
    imageUrl: createProductImage('HUUM Drop 9 kW', '#4b6b5a'),
    affiliateUrl: 'https://example.com/huum-drop-9kw',
    heaterTypes: ['electric'],
    kwRange: [8, 10],
  },
  {
    category: 'heater',
    name: 'Narvi NC 16 vedkamin',
    nameEn: 'Narvi NC 16 wood stove',
    description: 'Vedeldat aggregat för mindre till medelstora bastur.',
    descriptionEn: 'Wood-burning stove for small to mid-sized saunas.',
    priceSek: 13995,
    imageUrl: createProductImage('Narvi NC 16', '#8e4b36'),
    affiliateUrl: 'https://example.com/narvi-nc16',
    heaterTypes: ['wood'],
    kwRange: [7, 10],
  },
  {
    category: 'heater',
    name: 'Harvia M3 vedkamin',
    nameEn: 'Harvia M3 wood stove',
    description: 'Klassisk vedkamin med glaslucka för 6–13 m³ bastu.',
    descriptionEn: 'Classic wood-burning stove with a glass door, for 6–13 m³ saunas.',
    priceSek: 12995,
    imageUrl: createProductImage('Harvia M3', '#7c332f'),
    affiliateUrl: 'https://example.com/harvia-m3',
    heaterTypes: ['wood'],
    kwRange: [6, 10],
  },
  {
    category: 'heater',
    name: 'Kastor Karhu 16',
    description: 'Robust vedkamin med hög effekt för större familjebastu.',
    descriptionEn: 'Sturdy, high-output wood-burning stove for larger family saunas.',
    priceSek: 15990,
    imageUrl: createProductImage('Kastor Karhu 16', '#5e3a25'),
    affiliateUrl: 'https://example.com/kastor-karhu-16',
    heaterTypes: ['wood'],
    kwRange: [9, 13],
  },
  {
    category: 'chimney',
    name: 'Schiedel modulskorsten premium',
    nameEn: 'Schiedel modular chimney premium',
    description: 'Isolerat skorstenspaket för vedeldad utebastu.',
    descriptionEn: 'Insulated chimney kit for a wood-fired outdoor sauna.',
    priceSek: 16990,
    imageUrl: createProductImage('Schiedel Premium', '#67788e'),
    affiliateUrl: 'https://example.com/schiedel-premium',
    heaterTypes: ['wood'],
  },
  {
    category: 'door',
    name: 'Härdad bastudörr premium',
    nameEn: 'Tempered glass sauna door premium',
    description: 'Dörr i härdat glas med trähandtag.',
    descriptionEn: 'Tempered glass door with a wooden handle.',
    priceSek: 5990,
    imageUrl: createProductImage('Bastudörr Premium', '#5b6c77'),
    affiliateUrl: 'https://example.com/bastudorr-premium',
    heaterTypes: ['wood', 'electric'],
  },
  {
    category: 'lighting',
    name: 'LED-kit varmvit underlav',
    nameEn: 'Warm-white LED kit under the bench',
    description: 'Värmetålig stämningsbelysning för bastu.',
    descriptionEn: 'Heat-resistant mood lighting for the sauna.',
    priceSek: 2290,
    imageUrl: createProductImage('LED Underlav', '#6f5f2b'),
    affiliateUrl: 'https://example.com/led-underlav',
    heaterTypes: ['wood', 'electric'],
  },
];
